<template>
  <page>
    <lazy-div :load="doInit">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Package Standard Risk Text</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Package Standard Risk Text</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">View Package Standard Risk Text</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="!newMode" color="primary" dark class=" mr-2" @click.native="doNext">
            Package Standard Item Text <v-icon right>mdi-view-list</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode">
                <v-autocomplete
                  :items="scheme"
                  v-model="form.scheme"
                  :label="label.scheme"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('scheme')"
                  data-vv-name="scheme"
                  :data-vv-as="label.scheme"
                  v-validate="'required'"
                  clearable
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <!-- Scheme Review -->
            <v-layout row wrap>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ label.scheme }}</v-subheader>
                <div class="queryValue" v-for="item in filterSchemeList" :key="item.label">{{ item.label }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode">
                <v-text-field
                  v-model="form.riskNo"
                  :label="label.riskNo"
                  :error-messages="errors.collect('riskNo')"
                  data-vv-name="riskNo"
                  :data-vv-as="label.riskNo"
                  v-validate="'required|numeric|mustGreaterThenZero'"
                ></v-text-field>
              </v-flex>
              <!-- Review -->
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ label.riskNo }}</v-subheader>
                <div class="queryValue">{{ form.riskNo }}</div>
              </v-flex>

              <v-flex xs6 v-if="!queryMode">
                <v-autocomplete
                  :items="buscls"
                  v-model="form.busCls"
                  :label="label.busCls"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('form.busCls')"
                  data-vv-name="form.busCls"
                  :data-vv-as="label.busCls"
                  v-validate="'required'"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ label.busCls }}</v-subheader>
                <div class="queryValue" v-for="item in filterBusClsList" :key="item.label">{{ item.label }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 v-if="!queryMode">
                <v-text-field
                  v-model="form.stdRiskTxtRef"
                  :label="label.stdRiskTxtRef"
                  :error-messages="errors.collect('stdRiskTxtRef')"
                  data-vv-name="stdRiskTxtRef"
                  :data-vv-as="label.stdRiskTxtRef"
                  v-validate="'required'"
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="getHelpList('stdRiskTxtRef')">mdi-magnify</v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ label.stdRiskTxtRef }}</v-subheader>
                <div class="queryValue">{{ getItemValue(form.stdRiskTxtRef, stdrts).label }}</div>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12 v-if="!queryMode">
                <v-textarea
                  :label="label.stdRiskTxtLn"
                  v-model="queryForm.stdRiskTxtLn"
                  :error-messages="errors.collect('stdRiskTxtLn')"
                  data-vv-name="stdRiskTxtLn"
                  :data-vv-as="label.stdRiskTxtLn"
                  readonly
                ></v-textarea>
              </v-flex>
              <v-flex xs12 v-else>
                <v-subheader class="queryLabel">{{ label.stdRiskTxtLn }}</v-subheader>
                <div class="queryValue">{{ queryForm.stdRiskTxtLn }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 v-if="!queryMode">
                <v-textarea
                  :label="label.stdRiskTxtDetLn"
                  v-model="queryForm.stdRiskTxtDetLn"
                  :error-messages="errors.collect('stdRiskTxtDetLn')"
                  data-vv-name="stdRiskTxtDetLn"
                  :data-vv-as="label.stdRiskTxtDetLn"
                  readonly
                ></v-textarea>
              </v-flex>
              <v-flex xs12 v-else>
                <v-subheader class="queryLabel">{{ label.stdRiskTxtDetLn }}</v-subheader>
                <div class="queryValue">{{ queryForm.stdRiskTxtDetLn }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ label.createdBy }}</v-subheader>
                <div class="queryValue">{{ form.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ label.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(form.createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ label.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ form.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ label.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(form.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-spacer class="mt-3"></v-spacer>
          <v-layout>
            <v-flex xs6>
              <v-btn color="red darken-1" dark class=" mr-2" @click.native="doCancel">
                Cancel
                <v-icon right dark>mdi-cancel</v-icon>
              </v-btn>
              <v-btn v-if="!queryMode" color="primary" dark class=" mr-2" @click.prevent="doSave" :loading="submitting">
                Save
                <v-icon right>mdi-content-save</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-dialog v-model="stdRiskTxtList" width="900px" persistent>
            <stdRiskTxt-help-list
              v-if="stdRiskTxtHelpList"
              :srit="form.stdRiskTxtRef"
              @close="doClose"
              @doAssign="doAssign($event)"
            ></stdRiskTxt-help-list>
          </v-dialog>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { commonMixins } from '@/mixins/common/commonMixin'
import { formatDisplayDate } from '@/utils/date'
import { removeFormatNumber } from '@/utils/number.js'
import { expandURI } from '@/utils/ajax'
import StdRiskTxtHelpList from './StdRiskTxtHelpList.vue'

export default {
  data() {
    return {
      submitting: false,
      newMode: false,
      reviewMode: false,
      queryMode: false,
      scheme: [],
      buscls: [],
      stdrisktxt: [],
      stdrts: [],
      label: {
        scheme: 'Scheme',
        riskNo: 'Risk No.',
        busCls: 'Default Business Class',
        stdRiskTxtRef: 'Standard Risk Text Reference',
        stdRiskTxtLn: 'Standard Risk Text Line',
        stdRiskTxtDetLn: 'Standard Risk Text Detail Line',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        scheme: null,
        riskNo: '0',
        busCls: null,
        stdRiskTxtRef: null,
        createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      queryForm: {
        stdRiskTxtLn: null,
        stdRiskTxtDetLn: null
      },
      today: new Date(),
      loading: false,
      stdRiskTxtHelpList: false,
      stdRiskTxtList: false
    }
  },
  methods: {
    async doInit() {
      await this.$store.dispatch('pkgStdRiskTxtInit')
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataList('scheme')
      this.getCommonDataList('buscls')
      this.getCommonDataList('stdrisktxt')
      if (this.newTranMode) {
        this.form.createdDate = new Date()
      } else {
        this.fetchData(true)
      }
      this.fetchStdRiskTxt()
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newTranMode) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doNext() {
      this.$router.push({ name: 'pkgStdItemTxt' })
    },
    async doCreate() {
      const apiURI = this.menu.createPkgStdRiskTxt
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'pkgStdRiskTxt' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updatePkgStdRiskTxt
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'pkgStdRiskTxt' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async fetchData() {
      const apiURI = this.menu.getPkgStdRiskTxt
      if (apiURI) {
        try {
          const expand = {
            scheme: this.pkgStdRiskTxtId.scheme,
            riskNo: this.pkgStdRiskTxtId.riskNo
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.form.scheme = data.pkgStdRskTxt.scheme
            this.form.riskNo = data.pkgStdRskTxt.riskNo
            this.form.busCls = data.pkgStdRskTxt.busCls
            this.form.stdRiskTxtRef = data.pkgStdRskTxt.stdRiskTxtRef
            this.form.createdBy = data.createdBy
            this.form.createdDate = data.createdDate
            this.form.modifiedBy = data.modifiedBy
            this.form.modifiedDate = data.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async fetchStdRiskTxt() {
      const apiUrl = this.menu.stdRiskTxts
      if (apiUrl) {
        try {
          this.stdrts = []
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            data.map((element) => {
              const obj = {
                label: element.label,
                value: element.value,
                detLn: element.secondaryValue,
                txtLn: element.thirdValue
              }
              this.stdrts.push(obj)
            })
          }
        } catch (err) {
          this.stdrts = []
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doCancel() {
      this.$router.push({ name: 'pkgStdRiskTxt' })
    },
    formatDisplayDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    getTxtLn(event) {
      if (this.form.stdRiskTxtRef !== '') {
        for (let std of this.stdrts) {
          if (event === std.value) {
            this.queryForm.stdRiskTxtLn = std.txtLn
            this.queryForm.stdRiskTxtDetLn = std.detLn
          }
        }
        return {}
      } else {
        this.queryForm.stdRiskTxtLn = undefined
        this.queryForm.stdRiskTxtDetLn = undefined
      }
    },
    getHelpList(fieldName) {
      if (fieldName === 'stdRiskTxtRef') {
        this.stdRiskTxtHelpList = true
        this.stdRiskTxtList = true
      }
    },
    doAssign(Obj) {
      if (Obj.from === 'stdRiskTxtRef') {
        this.form.stdRiskTxtRef = Obj.stdRiskTxtRef.stdRiskTxtRef
        this.queryForm.stdRiskTxtLn = Obj.stdRiskTxtRef.stdRiskTxtLn
        this.queryForm.stdRiskTxtDetLn = Obj.stdRiskTxtRef.stdRiskDetLn
      }
    },
    doClose() {
      this.stdRiskTxtHelpList = false
      this.stdRiskTxtList = false
    }
  },
  created() {
    const jsonData = JSON.parse(sessionStorage.getItem('pkgStdRiskTxt'))
    this.$store.commit('PKGSTDRISKTXT_COMMIT_KEY', jsonData)

    if (this.pkgStdRiskTxtId.tranMode !== '') {
      if (this.pkgStdRiskTxtId.tranMode === 'New') {
        this.newMode = true
      } else if (this.pkgStdRiskTxtId.tranMode === 'Review') {
        this.reviewMode = true
      } else if (this.pkgStdRiskTxtId.tranMode === 'Query') {
        this.queryMode = true
      }
    }

    const mustGreaterThenZero = {
      getMessage: (field, args) => {
        return field + ' cannot be 0'
      },
      validate: (value, args) => {
        return removeFormatNumber(value) >= 0.000001
      }
    }

    this.$validator.extend('mustGreaterThenZero', mustGreaterThenZero)
  },
  watch: {
    'form.stdRiskTxtRef': function (value) {
      if (this.form.stdRiskTxtRef !== '' || this.form.stdRiskTxtRef !== undefined || this.form.stdRiskTxtRef !== null) {
        for (let std of this.stdrts) {
          if (value === std.value) {
            this.queryForm.stdRiskTxtLn = std.txtLn
            this.queryForm.stdRiskTxtDetLn = std.detLn
          }
        }
        return {}
      } else {
        this.queryForm.stdRiskTxtLn = undefined
        this.queryForm.stdRiskTxtDetLn = undefined
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.pkgParam.pkgStdRiskTxt.menu
    },
    newTranMode() {
      return this.pkgStdRiskTxtId.tranMode === 'New'
    },
    pkgStdRiskTxtId() {
      return this.$store.state.pkgParam.pkgStdRiskTxt.pkgStdRiskTxtId
    },
    filterSchemeList() {
      return this.scheme.filter((list) => {
        return list.value === this.form.scheme
      })
    },
    filterBusClsList() {
      return this.buscls.filter((list) => {
        return list.value === this.form.busCls
      })
    },
    filterStdRiskTxtRefList() {
      return this.stdrisktxt.filter((list) => {
        return list.value === this.form.stdRiskTxtRef
      })
    }
  },
  mixins: [MessageMixin, commonAjaxMixin, commonMixins],
  components: {
    StdRiskTxtHelpList
  }
}
</script>
